import { combineReducers } from "redux"

// Front
import Layout from "./layout/reducer"

// Authentication
import Login from "./auth/login/reducer"
import ForgetPassword from "./auth/forgetpwd/reducer"
import Profile from "./auth/profile/reducer"

// brands
import brands from "./brands/reducer"

// merchants
import merchants from "./merchants/reducer"

// merchants group
import merchantGroup from "./merchant-group/reducer"

// offers
import offers from "./offers/reducer"

// notifications
import notifications from "./notifications/reducer"

//user menu
import userMenu from "./auth/user-menu/reducer"

// app init
import appInfo from "./appInit/reducer"

// users
import users from "./users/reducer"

// dashboard
import dashboard from "./dashboard/reducer"

const rootReducer = combineReducers({
  // public
  Layout,
  Login,
  ForgetPassword,
  Profile,
  brands,
  merchants,
  merchantGroup,
  offers,
  notifications,
  userMenu,
  appInfo,
  users,
  dashboard,
})

export default rootReducer
